export function getChargebeeBillingUrl(region) {
    if (region === "eu" || region?.startsWith("eu-")) {
        return "https://app.eu.chargebee.com/login";
    }

    if (region === "au" || region?.startsWith("ap-")) {
        return "https://app.au.chargebee.com/login";
    }

    return "https://app.chargebee.com/login";
}
